import { Utils, Row } from '@microfrontends/react-components'
import styled from 'styled-components'
import { ContentWrapper } from '../Banner/Banner.css'

export const CompanyFilter = styled.div`
    position: absolute;
    top: 32px;
    right: 32px;
`

export const CompanyListSectionWrapper = styled.div`
    width: 100%;
    > div {
        padding: 32px 32px 16px 32px;
        @media screen and (max-width: ${Utils.screens.mobile}px) {
            padding: 16px;
            background-color: transparent;
            border: none;
            padding: 0;
        }
    }
    h2 {
        margin-bottom: 16px;
        line-height: 28px;
        height: 40px;
        display: flex;
        align-items: center;
        span {
            color: #999;
            font-size: 24px;
            margin-left: 4px;
        }
    }
    ${ContentWrapper} {
        @media screen and (max-width: ${Utils.screens.mobile}px) {
            h2 {
                display: block;
                font-weight: 700;
                height: initial;
                margin-bottom: 8px;
                span {
                    color: #999;
                    font-size: 14px;
                    font-weight: 400;
                }
            }
            ${CompanyFilter} {
                display: block;
                position: relative;
                top: initial;
                right: initial;
                margin-bottom: 8px;
            }
        }
    }
`

export const CompanySlider = styled(Row)`
    position: relative;
`

export const OverlayLoading = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    background-color: #fff;
    z-index: 10;
    width: 100%;
    > div {
        margin-right: 16px;
        width: 33.3%;
        &:last-child {
            margin-right: 0;
        }
    }
`

export const LoadMoreAction = styled.div`
    display: flex;
    justify-content: center;
`
